import { styled } from '@styles';

export const TimesaleLogoIcon = styled.img`
  width: 1.5rem;
  height: auto;
`;
